import { render } from "./TasasKardex.vue?vue&type=template&id=24f624ce&scoped=true"
import script from "./TasasKardex.vue?vue&type=script&lang=js"
export * from "./TasasKardex.vue?vue&type=script&lang=js"

import "../main.css?vue&type=style&index=0&lang=css&external"
import "./TasasKardex.vue?vue&type=style&index=1&id=24f624ce&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f624ce"]])

export default __exports__